import { render, staticRenderFns } from "./CardCarparkComponent.vue?vue&type=template&id=3f20d2ea&scoped=true"
import script from "./CardCarparkComponent.vue?vue&type=script&lang=js"
export * from "./CardCarparkComponent.vue?vue&type=script&lang=js"
import style0 from "./CardCarparkComponent.vue?vue&type=style&index=0&id=3f20d2ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f20d2ea",
  null
  
)

export default component.exports